
import { ActionButton } from "components/actionButton/actionButton";
import { Block } from "components/block/block";
import { ButtonBar } from "components/buttonBar/buttonBar";
import { CheckboxInput } from "components/input/checkbox/checkbox";
import { CheckboxStylishInput } from "components/input/checkboxStylish/checkboxStylish";
import { CheckMultiselectInput } from "components/input/checkMultiselect/checkMultiselect";
import { CodeInput } from "components/input/code/code";
import { CodeOutput } from "components/output/code/code";
import { ConfirmationDialogComponent } from "components/confirmationDialog/confirmationDialogComponent";
import { DateInput } from "components/input/date/date";
import { DateOutput } from "components/output/date/date";
import { DateRangeInput } from "components/input/dateRange/dateRange";
import { DateRangeOutput } from "components/output/dateRange/dateRange";
import { DateTimeInput } from "components/input/dateTime/dateTime";
import { DateTimeOutput } from "components/output/dateTime/dateTime";
import { DateTimeRangeInput } from "components/input/dateTimeRange/dateTimeRange";
import { DateTimeRangeOutput } from "components/output/dateTimeRange/dateTimeRange";
import { DoubleListSelectInput } from "components/input/doubleListSelect/doubleListSelect";
import { EmbeddedPage } from "components/pages/embeddedPage/embeddedPage";
import { ExpiredPassword } from "components/login/expiredPassword";
import { FileInput } from "components/input/file/file";
import { Form } from "components/form/form";
import { FullPage } from "components/pages/fullPage/fullPage";
import { Graph } from "components/graph/graph";
import { GridLayout } from "components/gridLayout/gridLayout";
import { Html } from "components/html/html";
import { IconOutput } from "components/output/icon/icon";
import { ImageInput } from "components/image/image";
import { Index } from "pages/index";
import { InlineMessage } from "components/message/inline/inlineMessage";
import { InlineMessages } from "components/message/inline/inlineMessages";
import { InputMatrix } from "components/input/matrix/matrix";
import { LDSRow } from "components/lds/row/row";
import { LinkTree } from "components/linkTree/linkTree";
import { LiveDesignSystem } from "components/lds/page/page";
import { Login } from "components/login/login";
import { MainDashboard } from "components/mainDashboard/mainDashboard";
import { Markdown } from "components/markdown/markdown";
import { MultiSearcherWithComposedCode } from "components/input/multiSearcherWithComposedCode/multiSearcherWithComposedCode";
import { MultiTextInput } from "components/input/multitext/multitext";
import { MultiTextOutput } from "components/output/multitext/multitext";
import { MultivalueTextInput } from "components/input/multivalueText/multivalueText";
import { Notifications } from "components/notifications/notifications";
import { NumberInput } from "components/input/number/number";
import { NumberId } from "components/input/id/numberId";
import { NumbersId } from "components/input/id/numbersId";
import { NumberOutput } from "components/output/number/number";
import { ObjectId } from "./input/id/objectId";
import { PasswordInput } from "components/input/password/password";
import { RadioSelectInput } from "components/input/radioSelect/radioSelect";
import { ReferenceTable } from "./input/referenceTable/referenceTable";
import { RichText } from "components/markdown/richtext";
import { SearcherWithComposedCode } from "components/input/searcherWithCode/searcherWithComposedCode/searcherWithComposedCode";
import { SearcherWithSingleCode } from "components/input/searcherWithCode/searcherWithSingleCode/searcherWithSingleCode";
import { SelectInput } from "components/input/select/select/select";
import { SelectInputWithoutS6 } from "components/input/select/selectWithoutS6/select";
import { SelectMultipleCompactInput } from "components/input/select/selectMultipleCompact/selectMultipleCompact";
import { SelectMultipleInput } from "components/input/select/selectMultiple/selectMultiple";
import { SideMenu } from "components/menu/sideMenu";
import { Signature } from "components/signature/signature";
import { StackedPage } from "components/stackedPage/stackedPage";
import { Table } from "components/table/table";
import { Tab } from "components/tabs/tab";
import { Tabs } from "components/tabs/tabs";
import { TextAreaCompactInput } from "components/input/textAreaCompact/textAreaCompact";
import { TextAreaInput } from "components/input/textArea/textArea";
import { Text } from "components/text/text";
import { TextId } from "components/input/id/textId";
import { TextInput } from "components/input/text/text";
import { TextOutput } from "components/output/text/text";
import { TextsId } from "components/input/id/textsId";
import { Tile } from "components/tiles/tile";
import { TimeInput } from "components/input/time/time";
import { TimeOutput } from "components/output/time/time";
import { TreeInput } from "components/input/tree/tree";

import { initSislo6WebComponents } from "components/components/initComponents";

import numbro from "numbro";
import languages from "numbro/dist/languages.min";


export class ComponentFactory {
    private static registry = {};
    public static get(componentType: string) {
        return this.registry[componentType];
    }

    public static register(name, module) {
        this.registry[name] = module;
    }
    public static registerFromObject(modules) {
        for (const key in modules) {
            if (modules.hasOwnProperty(key)) {
                const module = modules[key];
                this.registry[key] = module;
            }
        }
    }
}

// Force the inclusion of the components in the bundle
export async function initCompoments() {

    initSislo6WebComponents();

    //Register language necessary for numbro library
    numbro.registerLanguage(languages['es-ES']);
    numbro.registerLanguage(languages['fr-FR']);
    numbro.registerLanguage(languages['en-GB']);
    numbro.registerLanguage(languages['pt-PT']);

    ComponentFactory.registerFromObject({
        "actionButton": ActionButton,
        "block": Block,
        "buttonBar": ButtonBar,
        "checkboxInput": CheckboxInput,
        "checkboxStylishInput": CheckboxStylishInput,
        "checkMultiselectInput": CheckMultiselectInput,
        "codeInput": CodeInput,
        "codeOutput": CodeOutput,
        "confirmationDialog": ConfirmationDialogComponent,
        "dateInput": DateInput,
        "dateOutput": DateOutput,
        "dateRangeInput": DateRangeInput,
        "dateRangeOutput": DateRangeOutput,
        "dateTimeInput": DateTimeInput,
        "dateTimeOutput": DateTimeOutput,
        "dateTimeRangeInput": DateTimeRangeInput,
        "dateTimeRangeOutput": DateTimeRangeOutput,
        "doubleListSelectInput": DoubleListSelectInput,
        "embeddedPage": EmbeddedPage,
        "expiredPassword": ExpiredPassword,
        "fileInput": FileInput,
        "form": Form,
        "fullPage": FullPage,
        "graph": Graph,
        "gridLayout": GridLayout,
        "html": Html,
        "iconOutput": IconOutput,
        "image": ImageInput,
        "pages.indexPage": Index,
        "inlineMessage": InlineMessage,
        "inlineMessages": InlineMessages,
        "inputMatrix": InputMatrix,
        "liveDesignSystemRow": LDSRow,
        "linkTree": LinkTree,
        "liveDesignSystemPage": LiveDesignSystem,
        "login": Login,
        "mainDashboard": MainDashboard,
        "markdown": Markdown,
        "menu": SideMenu,
        "multisearcherWithComposedCode": MultiSearcherWithComposedCode,
        "multiTextInput": MultiTextInput,
        "multiTextOutput": MultiTextOutput,
        "multivalueInput": MultivalueTextInput,
        "notifications": Notifications,
        "numberInput": NumberInput,
        "numberId": NumberId,
        "numbersId": NumbersId,
        "numberOutput": NumberOutput,
        "objectId": ObjectId,
        "passwordInput": PasswordInput,
        "radioSelectInput": RadioSelectInput,
        "referenceTable": ReferenceTable,
        "richtext": RichText,
        "searcherWithComposedCode": SearcherWithComposedCode,
        "searcherWithSingleCode": SearcherWithSingleCode,
        "selectInput": SelectInput,
        "selectInputWithoutS6": SelectInputWithoutS6,
        "selectMultipleInput": SelectMultipleInput,
        "selectMultipleCompactInput": SelectMultipleCompactInput,
        "signature": Signature,
        "stackedPage": StackedPage,
        "table": Table,
        "tab": Tab,
        "tabs": Tabs,
        "textAreaCompactInput": TextAreaCompactInput,
        "textAreaInput": TextAreaInput,
        "text": Text,
        "textId": TextId,
        "textInput": TextInput,
        "textOutput": TextOutput,
        "textsId": TextsId,
        "tile": Tile,
        "timeInput": TimeInput,
        "timeOutput": TimeOutput,
        "tree": TreeInput,
    });
}
